import clsx from 'clsx'
import React from 'react'
import {
  Control,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { MostBookedRegionType } from '../../location-picker/location-picker.type'
import { TravelTypeEnum } from '../../../../lib/graphql'
import { useSeminarAppContext, useTravelTypeContext } from '../../../contexts'
import { Checkbox, TravelTypePicker } from '../../../forms'
import { TravelTypeModeEnum } from '../../../forms/travel-type-picker/travel-type-container/travel-type-container.enum'
import { SearchCityDatesAdultsModeEnum } from '../../../molecules/search-city-dates-adults/search-city-dates-adults.enum'
import { SearchCityDatesAdults } from '../../../molecules/search-city-dates-adults/SearchCityDatesAdults'
import { SearchCityDatesAdultsV2 } from '../../../molecules/search-city-dates-adults-v2/SearchCityDatesAdultsV2'

interface IHouseSearchHeaderProps<T extends FieldValues> {
  control: Control<T, any>
  setValue: UseFormSetValue<T>
  getValues: UseFormGetValues<T>

  watch?: UseFormWatch<T>
  searchClick: (values: T) => void
  isLoading: boolean
  classnames?: {
    travelType?: string
  }
  isSortSelectorVisible?: boolean
  isHeader?: boolean
  mostBookedRegions?: MostBookedRegionType[]
  isSmallDevice?: boolean
  isFromSearchPage?: boolean
}

export const HouseSearchHeader = <T extends FieldValues>({
  control,
  setValue,
  getValues,
  watch,
  searchClick,
  isLoading,
  classnames,
  isSortSelectorVisible,
  isHeader = false,
  mostBookedRegions = [],
  isSmallDevice = false,
  isFromSearchPage = false,
}: IHouseSearchHeaderProps<T>) => {
  const { travelType } = useTravelTypeContext()
  const { isSeminarSearchEnabled } = useSeminarAppContext()

  const shouldDisplayPrivatisedCheckBox =
    travelType !== TravelTypeEnum.CORPORATE_EVENING_EVENT

  return (
    <div
      className={clsx(s.header, {
        [s.sortSelectorIsHidden]: !isSortSelectorVisible,
      })}
    >
      {!isHeader && (
        <div
          className={clsx(s.nightType, {
            [classnames?.travelType ?? '']: classnames?.travelType,
          })}
        >
          <TravelTypePicker mode={TravelTypeModeEnum.HOUSE_SEARCH} />
        </div>
      )}

      {isSeminarSearchEnabled && !isHeader ? (
        <div
          className={clsx(s.searchDateAdults, {
            [s.searchDateAdultsHeader]: isHeader,
          })}
        >
          <SearchCityDatesAdultsV2<T>
            getValues={getValues}
            onSubmit={searchClick}
            mode={SearchCityDatesAdultsModeEnum.HOUSE_SEARCH}
            isLoading={isLoading}
            isHeader={isHeader}
            mostBookedRegions={mostBookedRegions}
            isSmallDevice={isSmallDevice}
            isFromSearchPage={isFromSearchPage}
            watch={watch}
          />
        </div>
      ) : (
        <div
          className={clsx(s.searchDateAdults, {
            [s.searchDateAdultsHeader]: isHeader,
          })}
        >
          <SearchCityDatesAdults<T>
            control={control}
            setValue={setValue}
            getValues={getValues}
            searchClick={() => searchClick(getValues())}
            mode={SearchCityDatesAdultsModeEnum.HOUSE_SEARCH}
            isLoading={isLoading}
            isHeader={isHeader}
          />

          {!isHeader && shouldDisplayPrivatisedCheckBox ? (
            <div className={s.checkboxContainer}>
              <Checkbox
                control={control}
                rules={{}}
                name='houseCanBePrivatised'
                className={s.checkbox}
                label={
                  <FormattedMessage
                    id='ui.HouseSearchHeader.label.privateHouse'
                    defaultMessage='Voir uniquement les lieux privatisés'
                  />
                }
              />
            </div>
          ) : null}
        </div>
      )}
    </div>
  )
}
